export const AUTH_HEADER = (token: string) => ({
  Authorization: `Bearer ${token}`,
})

export const TIMEZONE_HEADER = (timezone: string) => ({
  timezone,
})
